import { render, staticRenderFns } from "./ProductAnalyticsReport.vue?vue&type=template&id=4506abd3&"
import script from "./ProductAnalyticsReport.vue?vue&type=script&lang=js&"
export * from "./ProductAnalyticsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports